// @ts-nocheck
import { useEffect } from 'react';
import '@svgdotjs/svg.draggable.js';

import useStore from '../store/store';
import './soundTool.css';
import { Controllers } from './Controllers';
import Detail from './Detail.js';
import Multiband from './Multiband';

import { Source } from './graph/Source';
import { Receiver } from './graph/Receiver';
import { Line } from './graph/Line';
import { FirstBarrier } from './graph/FirstBarrier';
import { SecondBarrier } from './graph/SecondBarrier';
import { BuildingBarrier } from './graph/BuildingBarrier';
import { Shadows } from './graph/common/Shadows';
import { Ground } from './graph/Ground';
import { Grid } from './graph/Grid';
import { Container, Row, Col } from 'react-grid-system';

const ResizableTool = () => {
  const { width, height } = useStore(state => state.view);
  const setViewBox = useStore(state => state.setViewBox);
  const scenario = useStore((state) => state.scenario);

  useEffect(() => {
    const onResize = (e) => {
      if (window.innerWidth < 600) {
        setViewBox(400, 280);
      } else if (window.innerWidth >= 600) {
        setViewBox(1012, 435);
      }
    };
    onResize();
    window.addEventListener('resize', onResize);
    return () => {
      window.removeEventListener('resize', onResize);
    };
  }, []);

  return (
    <svg key={width} id="svg" width="100%" height="100%" viewBox={`0 0 ${width} ${height}`} style={{ borderRadius: '25px', backgroundColor: '#e2e7e6', marginTop: '60px' }}>
      <g id="above-ground">
        <g id="grid"><Grid /></g>
        <g id="shadows">
          <Shadows />
        </g>
        <g id="main">
          <Line />
          <Source />
          <Receiver />
        </g>
        <g id="barriers">
          {(scenario === 'singleBarrier' || scenario === 'doubleBarrier') && <FirstBarrier />}
          {scenario === 'doubleBarrier' && <SecondBarrier />}
          {scenario === 'building' && <BuildingBarrier />}
        </g>
      </g>
      <Ground />
    </svg>
  );
};

const SoundTool = () => {
  const sourceHeight = useStore(state => state.sourceHeight);
  const receiverHeight = useStore(state => state.receiverHeight);
  const barrierHeight = useStore(state => state.barrier1.height);
  //Source/Barrier Distance is barrierXpos
  const barrierXpos = useStore((state) => state.barrier1.distance);
  const distance = useStore((state) => state.distance);
  const BarrierToRecieverDistance = distance - barrierXpos;
  //sourceHeight = 2;//receiverHeight = 2;//distance = barrierXpos + BarrierToRecieverDistance;    //const receiverSPLNoBarrier = 100;
  /*
    use https://www.excelformulabeautifier.com/ to convert formulas to js
    $D$31 = reciever height                               c48 - source sound power dbA
    $D$29 = source height                                 c49 - validity (calculation)
    $D$32 = source to barrier distance                    c50 - barrier attenuation
    $D$33 = barrier to receiver distance                  c51 = Receiever SPL
    $D$30 = barrier height                                c52 - Receiver Noise Level
    $D$40 = path difference                               c46 = ABC Distance
    //=SQRT((D30-D29)^2+D32^2)                            c45 = path difference

    version 2
    c48 = Measurement Distance (meters)
    c49 = Source Noise ()
  */
  const pathA1 = Math.pow((barrierHeight - sourceHeight), 2);

  const pathA2 = Math.pow(barrierXpos, 2);

  // console.log({barrierXpos})
  // console.log({pathA2})
  const pathA = Math.sqrt(pathA1 + pathA2);
  const pathB1 = Math.pow((barrierHeight - receiverHeight), 2);
  const pathB2 = Math.pow(BarrierToRecieverDistance, 2);
  const pathB = Math.sqrt(pathB1 + pathB2);
  const pathC = Math.sqrt(Math.pow((receiverHeight - sourceHeight), 2) + Math.pow((Number(barrierXpos) + BarrierToRecieverDistance), 2));
  const PathDifference = pathA + pathB - pathC;

  //const sourceSoundPower = 96.8;
  //const frequency = 500;
  const frequency = useStore((state) => state.frequency);
  const setinitialMeasurementDistance = useStore((state) => state.setinitialMeasurementDistance);
  const setinitialSoundNoise = useStore((state) => state.setinitialSoundNoise);
  const setinitialSourceSoundPower = useStore((state) => state.setinitialSourceSoundPower);
  const setinitialFrequency = useStore((state) => state.setinitialFrequency);

  /* Just for initialisation */
  // setinitialSourceSoundPower(98.6);
  // setinitialSoundNoise(100);
  // setinitialMeasurementDistance(10);

  const sourceSoundPower = useStore((state) => state.initialSourceSoundPower);

  let valid = "Yes";

  const calcsB2a = 2 * PathDifference;

  const calcsB2b = (frequency / 343);

  const calcsB2c = calcsB2a * calcsB2b;

  let calcsB2 = ((sourceSoundPower === null) ? sourceSoundPower : Math.log10(calcsB2c));

  valid = (
    ((receiverHeight - sourceHeight) / (barrierXpos + BarrierToRecieverDistance)) > ((barrierHeight - sourceHeight) / barrierXpos)
      ?
      "visible"
      :
      (PathDifference === 0 ? "Grazing" :
        (
          (sourceSoundPower === null || sourceSoundPower === 0)
            ?
            sourceSoundPower
            :
            (
              (calcsB2 >= -3 && calcsB2 <= 3)
                ? "Yes"
                : "No"
            )
        )
      )
  )



  const barrierAttenuation = (
    (
      (receiverHeight - sourceHeight) / (barrierXpos + BarrierToRecieverDistance)
    )
      >
      (
        (barrierHeight - sourceHeight) / barrierXpos
      )
      ?
      0
      :
      (PathDifference === 0
        ?
        5
        :
        (
          (sourceSoundPower === null || sourceSoundPower === 0)
            ?
            sourceSoundPower
            :
            //7
            13.33 + 8.34
            * calcsB2 + 2.445
            * Math.pow(calcsB2, 2) - 0.8838
            * Math.pow(calcsB2, 3) - 0.3012
            * Math.pow(calcsB2, 4) + 0.1644
            * Math.pow(calcsB2, 5) + 0.01832
            * Math.pow(calcsB2, 6) - 0.010024
            * Math.pow(calcsB2, 7)
        )
      )
  )




  const receiverSPLNoBarrier = (sourceSoundPower === null ? sourceSoundPower : sourceSoundPower - 20 * Math.log10(distance) - 8);


  const RecieverNoiseLevel = receiverSPLNoBarrier - barrierAttenuation;

  //const measurementDistance = 10;
  //const sourceNoisePower = 100;

  const measurementDistance = useStore((state) => state.initialMeasurementDistance);
  const sourceNoisePower = useStore((state) => state.initialSoundNoise);

  const distanceAttenuation = (sourceNoisePower === null || sourceNoisePower === 0) ? sourceNoisePower : 20 * Math.log10(distance / measurementDistance);

  const barrierAttenuation2 = (
    (
      (receiverHeight - sourceHeight) / (barrierXpos + BarrierToRecieverDistance)
    )
      >
      (
        (barrierHeight - sourceHeight) / barrierXpos
      )
      ?
      0
      :
      (PathDifference === 0
        ?
        5
        :
        (
          (sourceNoisePower === null || sourceNoisePower === 0)
            ?
            sourceNoisePower
            :
            //7
            13.33 + 8.34
            * calcsB2 + 2.445
            * Math.pow(calcsB2, 2) - 0.8838
            * Math.pow(calcsB2, 3) - 0.3012
            * Math.pow(calcsB2, 4) + 0.1644
            * Math.pow(calcsB2, 5) + 0.01832
            * Math.pow(calcsB2, 6) - 0.010024
            * Math.pow(calcsB2, 7)
        )
      )
  )
  const recieverNoiseLevel2 = sourceNoisePower - barrierAttenuation2 - distanceAttenuation;

  return (
    <>
      <div className="container">
        <Container>
          <Controllers />
          <ResizableTool />
          <Multiband
            sourceHeight={sourceHeight}
            receiverHeight={receiverHeight}
            distance={distance}
            PathDifference={PathDifference}
            distanceAttenuation={distanceAttenuation}
            barrierHeight={barrierHeight}
            barrierXpos={barrierXpos}
            BarrierToRecieverDistance={BarrierToRecieverDistance}
            sourceSoundPower={sourceSoundPower}
            frequency={frequency}
            calcsB2={calcsB2}
            sourceNoisePower={sourceNoisePower}
            RecieverNoiseLevel2={recieverNoiseLevel2}
            RecieverNoiseLevel={RecieverNoiseLevel}
            receiverSPLNoBarrier={receiverSPLNoBarrier}

          />
        </Container>
      </div>
    </>
  );
};

export { SoundTool };
